/*
 * Jira Ticket:
 * Created Date: Mon, 23rd Nov 2020, 12:42:51 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import jwtDecode from 'jwt-decode';
import getToken from './getToken';

// partition an array based on isValid (e.g. ['apples','oranges'] => isOrange => (false) ['apples'] ; (true) ['oranges'])
export function partition(array, isValid) {
  return array.reduce(
    ([pass, fail], elem) => {
      return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []]
  );
}

export const goBack = () => {
  window.history.go(-1);
};

export const getIconNameAndPrefix = iconString => {
  if (iconString) {
    let [prefix, icon] = iconString.split(' ');
    if (icon) icon = icon.split('fa-')[1]; // remove the fa- e.g. fa-acorn -> acorn
    return [prefix, icon];
  }
  return [];
};

export const getLocalisedFieldByLanguage = ({
  language = 'en',
  source,
  localisations,
  format,
  defaultValue = null,
}) => {
  let localisedField = null;
  let localisation = null;
  if (localisations && localisations.length > 0) {
    localisation = localisations.find(
      localisation => localisation.language === language
    );
    localisedField = localisation && localisation[source];
  } else {
    localisedField = defaultValue;
  }
  if (format) {
    // apply the desired formatting
    localisedField = format(localisedField, localisation);
  }
  return localisedField;
};

export const checkNoPropertiesExist = (
  obj = {},
  fieldsToSkip = [],
  fields = []
) => {
  if (fields.length > 0) {
    for (let i = 0; i < fields.length; i++) {
      const field = fields[i];
      if (!fieldsToSkip.includes(field) && obj.hasOwnProperty(field)) {
        if (obj[field] && obj[field] != null && obj[field] !== '') return false; // a property exists
      }
    }
  }
  return true; // all properties are empty
};

export const supportedLanguages = process.env.REACT_APP_SUPPORTED_LANG.split(
  ' '
);

export const languageNames = (translatedLang = 'en') =>
  new Intl.DisplayNames([translatedLang], {
    type: 'language',
  });

export const setFilter = ({
  filter,
  setResourceFilter,
  currentFilter,
  checkFilterValues,
}) => {
  if (filter) {
    if (checkFilterValues(currentFilter, filter)) {
      const filterName = filter.name.split('_')[1];
      if (filter.value && filter.value.length > 0) {
        return setResourceFilter({
          [filterName]: filter.value,
        });
      }
      return setResourceFilter({ [filterName]: null });
    }
  }
  return setResourceFilter({});
};

export const reviewRatingString = n => '\u2605'.repeat(Number(n));

export const storePermission = async () => {
  const token = await getToken();
  if(token) {
    const decoded = jwtDecode(token)
    localStorage.setItem('permissions', JSON.stringify([decoded['custom:role']]))
  }
}
